<template>
  <div class="-mx-3">
    <div class="w-full flex items-center justify-between mb-4">
      <h3 class="text-secondary text-2xl font-bold ml-3">
        {{ title }}
      </h3>
      <router-link
        :to="link"
        class="text-secondary font-semibold hover:text-accent transition-default border-transparent mr-3 hover:border-b hover:border-accent"
        >{{ $t("video_carousel.see_all") }}</router-link
      >
    </div>
    <carousel :itemsToShow="itemsToShow" :itemsToScroll="1" snapAlign="start">
      <slide v-for="video in videos" :key="video.id">
        <VideoItem class="px-3" :video="video" :isTrending="video.isTrending" />
      </slide>

      <template #addons>
        <navigation />
      </template>
    </carousel>
  </div>
</template>
<script>
import "vue3-carousel/dist/carousel.css";
import { Carousel, Slide, Navigation } from "vue3-carousel";
import VideoItem from "@/components/UI/Video/VideoItem";
import { vueWindowSizeMixin } from "vue-window-size/mixin";
export default {
  name: "VideoListCarousel",
  mixins: [vueWindowSizeMixin()],
  data() {
    return {
      itemsToShow: 4,
    };
  },
  mounted() {
    this.calculateItemsToShow();
  },
  components: {
    VideoItem,
    Carousel,
    Slide,
    Navigation,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    link: {
      type: Object,
      default: () => ({ name: "Categories" }),
    },
    videos: {
      type: Array,
      required: true,
    },
  },
  watch: {
    $windowWidth() {
      this.calculateItemsToShow();
    },
  },
  methods: {
    calculateItemsToShow() {
      if (this.$windowWidth < 640) {
        this.itemsToShow = 1;
      } else if (this.$windowWidth < 1280) {
        this.itemsToShow = 2;
      } else {
        this.itemsToShow = 4;
      }
    },
  },
};
</script>